import apiBaseUrl from '../config/apiBaseUrl';

const graphqlEndpointURL = `${apiBaseUrl}/graphql`;
/**
 *
 */
export default async function fetchGraphQL(text, variables) {
  const response = await fetch(graphqlEndpointURL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: text,
      variables,
    }),
  });

  const responseBody = await response.json();
  return responseBody;
}
